/* 🤖 this file was generated by script */
export const wiconMenu04 = {
  name: 'menu_04',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12h18M3 6h18M9 18h12"/></svg>`,
};
